export function setCookie(cookieKey, cookieValue, expirationDays) {
    let previousCookieValue = getCookie(cookieKey);
    if (previousCookieValue != null || previousCookieValue != undefined || previousCookieValue != "") {
        deleteCookie(cookieKey);
    }
    const d = new Date();
    d.setTime(d.getTime() + (expirationDays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = `${cookieKey}=${cookieValue}; expires=${expires}`;
}

export function getCookie(cookieKey) {
    let name = cookieKey + "=";
    let cookiesSplit = document.cookie.split(';');
    for (let i = 0; i < cookiesSplit.length; i++) {
        let c = cookiesSplit[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function deleteCookie(cookieKey) {
    document.cookie = cookieKey + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}